export default __webpack_public_path__ + "89e69d146296119ef0607f91a9721243.svg";